import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FlightSearchStore } from '../flight-search.store';
import { Observable, of, switchMap, tap } from 'rxjs';
import { RequestState, RequestStatus } from '@shared/models/request-state';
import { SequenceRequest } from '@sequence/models/request/sequence.request';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-lookup-seq',
  templateUrl: './lookup-seq.component.html',
  styleUrl: './lookup-seq.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LookupSeqComponent implements OnInit {
  sequenceSearch$?: Observable<RequestState<SequenceRequest>>;

  constructor(
    private flightSearchStore: FlightSearchStore,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sequenceSearch$ = this.route.paramMap.pipe(
      switchMap((params) => {
        const flightNum = params.get('flightNumber');
        const dep = params.get('dep');
        const arr = params.get('arr');
        const date = params.get('date');

        if (flightNum && dep && arr && date) {
          return this.searchByFlight(flightNum, dep, arr, date);
        } else {
          return of(
            new RequestState<SequenceRequest>(
              RequestStatus.IsCompleteNoResponse,
            ),
          );
        }
      }),
    );
  }

  private searchByFlight(
    flightNum: string,
    dep: string,
    arr: string,
    date: string,
  ): Observable<RequestState<SequenceRequest>> {
    return this.flightSearchStore
      .getSequenceByFlight(flightNum, dep, date)
      .pipe(
        tap((requestState) => {
          if (requestState.response) {
            if (
              requestState.response.date &&
              requestState.response.number &&
              requestState.response.seat
            ) {
              const seqNum = requestState.response.number;
              const seat = requestState.response.seat;
              const seqDate = requestState.response.date;
              const flightUrl = this.createFlightUrl(
                seqNum,
                seat,
                seqDate,
                flightNum,
                dep,
                arr,
                date,
              );

              // replaceUrl used so that using back button goes back to search instead of getting stuck on this screen.
              this.router.navigate([flightUrl], { replaceUrl: true });
            }
          }
        }),
      );
  }

  /** Generates a flight URL for direct navigation. */
  private createFlightUrl(
    seqNum: string,
    seat: string,
    seqDate: string,
    flightNum: string,
    depStation: string,
    arrStation: string,
    flightDate: string,
  ): string {
    // Flight URL format: sequence/{seq num}/{seat}/{seq start date yyyy-mm-dd}/flight/{flight num}/{dep station}/{arr station}/{dep date}
    return `sequence/${seqNum}/${seat}/${seqDate}/flight/${flightNum}/${depStation}/${arrStation}/${flightDate}`;
  }
}
